/**
 * @file Pricing Popup
 */

import { gsap } from 'gsap';

/**
 * Pricing Popup component
 */
const vPricingPopup = () => {
	const pricingPopup = document.querySelector( '.v-pricing-popup' );

	if ( ! pricingPopup ) {
		return;
	}

	const close    = pricingPopup.querySelector( '.v-pricing-popup__close' );
	const backdrop = pricingPopup.querySelector( '.v-pricing-popup__backdrop' );
	const frame    = pricingPopup.querySelector( '.v-pricing-popup__frame' );
	const delay    = parseInt( pricingPopup.getAttribute( 'data-delay' ), 10 ) || 5000;
	const tl       = gsap.timeline( {
		paused:   true,
		defaults: {
			duration: .25,
			ease:     'sine.out',
		},
		onStart: () => {
			pricingPopup.classList.add( 'v-pricing-popup--open' );
		},
		onReverseComplete: () => {
			pricingPopup.classList.remove( 'v-pricing-popup--open' );
		},
	} )
		.from( backdrop, {
			opacity: 0,
		} )
		.from( frame, {
			yPercent: 10,
			opacity:  0,
		} );

	close.addEventListener( 'click', () => {
		tl.timeScale( 1.5 ).reverse();
	} );

	window.addEventListener( 'click', ( event ) => {
		if ( ! pricingPopup.classList.contains( 'v-pricing-popup--open' ) ) {
			return;
		}

		const { target } = event;

		if ( ! frame.contains( target ) ) {
			tl.timeScale( 1.5 ).reverse();
		}
	} );

	setTimeout( () => {
		tl.play();
	}, delay );
};

export default vPricingPopup;
